module.exports = __webpack_public_path__ + "static/img/hero1.7759eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero1.png
// module id = BPeO
// module chunks = 1